var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"information-description"},[_vm._v(" Account connections are how Ply connects to your apps. Your information is secure and in your control. "),_c('DocsDispatcher',{attrs:{"docsSrc":"https://info.ply.io/privacy"}},[_c('a',{attrs:{"href":"#"}},[_vm._v("Learn more")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }